export const DEFAULT_FORMAT = 'YYYY-MM-DD';
export const DETAILED_FORMAT_WITH_UTC_OFFSET = 'MMM DD, YYYY [at] h:mm a (UTC Z)';
